module.exports = __webpack_public_path__ + "static/media/cf.8f764c6d.svg";